<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">
          <b>首页</b>
        </el-breadcrumb-item> -->
        <el-breadcrumb-item>审计日志</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <!--工具条 begin-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="操作类型：">
          <el-input v-model="searchForm.type" placeholder="操作类型"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="findResult(null)">查询</el-button>
        </el-form-item>
    </el-form>
    </el-col> 
    <!--工具条 end-->

    <!-- 列表显示 begin-->
    <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
    <el-table :data="auditLogs" style="width: 100%;overflow: auto;" stripe highlight-current-row v-loading="tableLoading" class="tablebar">
      <!-- 第一行显示数据 -->
      <!-- <el-table-column
        width="50">
      </el-table-column> -->
      <el-table-column prop="createTime" label="操作日期" sortable align="center"></el-table-column>
      <el-table-column prop="userName" label="操作用户" sortable align="center"></el-table-column>
      <el-table-column prop="eventDescribe" label="操作内容" sortable align="center"></el-table-column>
      <div slot="empty" class="empty">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </el-table>
    </el-col>
    <!-- 列表显示 end-->
    <!--底部分页-->
    <el-col :span="24" class="foolbar">
        <!-- hide-on-single-page  -->
      <el-pagination 
        background 
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pageSize"
        :page-sizes = pageSizes
        :total="total" 
        hide-on-single-page 
        style="float:right;">
      </el-pagination>
    </el-col>
    <!-- 在此添加新的页面元素 -->
  </el-row>
</template>

<script>
import API_AUDIT from "../../api/api_audit";

export default {
  data() {
    return {
        searchForm:{
          type:"",
        },

        //列表显示相关数据
        auditLogs: [],
        //页码
        page: 1,
        //每页数量
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        //总数
        total: 0,
        clientHeight: window.innerHeight - 258,
        //页面载入状态
        tableLoading: false,
    };
  },
  methods: {
    //获取所有结果
    findAllLogs(){
      let that = this;
      this.tableLoading = true
      let params = {
        page: that.page,
        pageSize: that.pageSize,
        searchType: that.searchForm.type,
      };
      API_AUDIT.auditLogsGet(params)
      .then(res=>{
        if(res && res.auditLogs){
          that.auditLogs = Object.values(res.auditLogs);
          that.total = res.total;
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
      }).finally(()=>{
          this.tableLoading = false
        });
    },

    //
    searchLogs() {
      let that = this;
      this.tableLoading = true
      let params = {
        searchType: that.searchForm.type,
        page: that.page,
        pageSize: that.pageSize,
      };
      console.log("......searchLogs params:" + JSON.stringify(params));
      //发送http请求
      API_AUDIT.auditLogsGet(params)
        .then(res => {
            if(res && res.auditLogs){
                that.auditLogs = Object.values(res.auditLogs);
                that.total = res.total;
                console.log(
                    "......searchLogs:" + JSON.stringify(that.auditLogs)
                );
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        }).finally(()=>{
          this.tableLoading = false
        });
    },

    getRows: function(_page) {
      this.page = _page;
      this.searchLogs();
    },

    handleSizeChange(val) {
        this.pageSize = val;
        this.searchLogs();
      },

    //分页选择处理
    handleCurrentChange: function(val) {
      this.getRows(val);
    },

    findResult(){
      //点击查询按钮，分页初始化为1
      let _page = 1;
      //重新搜索时进行重置
      this.total = 0;
      //查询前清除查询列表信息
      this.auditLogs = null;
      //进行分页查询
      this.getRows(_page);
    },

    //初始化表格高度
    initHeight: function() {
      this.clientHeight = (document.documentElement.clientHeight - 258) + 'px';
    },

    
  },
  mounted() {
    window.addEventListener('resize', this.initHeight);
    this.initHeight();
    this.findAllLogs();
  }
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #ab99bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/OperationLog.vue